<template>
  <el-card shadow="false" style="margin-bottom: 24px">
    <SummaryFinancial v-if="$route.query.productNum.toString() === '1'" />
    <SummaryCommercial v-if="$route.query.productNum.toString() === '2'" />
  </el-card>
</template>

<script>
import SummaryFinancial from './mock-component/summaryFinancial'
import SummaryCommercial from './mock-component/summaryCommercial'

export default {
  components: { SummaryFinancial, SummaryCommercial },
}
</script>

<style scoped></style>
